module.exports = "mat-drawer {\r\n    width: 200px;\r\n    \r\n  }\r\n\r\nmat-drawer-content{\r\n  min-height: 700px;\r\n}\r\n\r\n.example-fill-remaining-space {\r\n  /* This fills the remaining space, by using flexbox. \r\n      Every toolbar row uses a flexbox row layout. */\r\n  -webkit-box-flex: 1;\r\n      -ms-flex: 1 1 auto;\r\n          flex: 1 1 auto;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main